import { QrTemplate, QrTemplateColors, EditableSlot } from './types';

const SANS = '-apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif';
const SERIF = 'Georgia, "Times New Roman", serif';

const slots: EditableSlot[] = [
  {
    id: 'eyebrow',
    label: 'Oberes Label',
    defaultValue: 'TERMIN  •  WHATSAPP',
    modeVariants: { whatsapp: 'TERMIN  •  WHATSAPP', vcard: 'KONTAKT  •  SPEICHERN' },
    positionable: true,
  },
  {
    id: 'tagline',
    label: 'Tagline',
    defaultValue: 'Termine rund um die Uhr.',
    modeVariants: { whatsapp: 'Termine rund um die Uhr.', vcard: 'Immer griffbereit.' },
    positionable: true,
  },
  {
    id: 'footer',
    label: 'Footer-Tag',
    defaultValue: 'WHATSAPP  •  ANRUF  •  24/7',
    positionable: true,
  },
  {
    id: 'caption',
    label: 'QR-Caption',
    defaultValue: 'SCANNEN  &  BUCHEN',
    modeVariants: { whatsapp: 'SCANNEN  &  BUCHEN', vcard: 'SCANNEN  &  SPEICHERN' },
    positionable: true,
  },
];

export const businessCard: QrTemplate = {
  id: 'business-card',
  name: 'Visitenkarte',
  description: 'Klassische Visitenkarte im Querformat – elegante Typografie links, QR-Code rechts.',
  format: '85×55 mm, 300 dpi (1004×650 px)',
  canvasWidth: 1004,
  canvasHeight: 650,
  slots,

  defaultColors: {
    background: '#F6F1E8',
    surface:    '#FFFFFF',
    text:       '#1C1A18',
    textMuted:  '#8A827A',
    accent:     '#C9A96E',
    onAccent:   '#1C1A18',
  } satisfies QrTemplateColors,

  render: ({ ctx, canvas, qrImage, business, colors, slotValues, slotOffsets }) => {
    const W = canvas.width;
    const H = canvas.height;
    const { background, text, textMuted, accent } = colors;
    const WHITE = '#FFFFFF';

    ctx.fillStyle = background;
    ctx.fillRect(0, 0, W, H);

    const LEFT_PAD = 55;
    const LEFT_MAX_W = 500;
    const DIVIDER_X = 600;

    ctx.fillStyle = accent;
    ctx.fillRect(LEFT_PAD, 30, 60, 2);
    ctx.fillRect(LEFT_PAD, H - 32, 60, 2);

    ctx.save();
    ctx.fillStyle = accent;
    ctx.globalAlpha = 0.35;
    ctx.fillRect(DIVIDER_X, 80, 1, H - 160);
    ctx.restore();

    const eyeOff = slotOffsets.eyebrow;
    ctx.save();
    ctx.font = `500 14px ${SANS}`;
    (ctx as any).letterSpacing = '5px';
    ctx.fillStyle = accent;
    ctx.textAlign = 'left';
    ctx.fillText(slotValues.eyebrow, LEFT_PAD + 1 + eyeOff.x, 110 + eyeOff.y);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();

    let nameSize = 54;
    ctx.font = `700 ${nameSize}px ${SERIF}`;
    while (ctx.measureText(business.name).width > LEFT_MAX_W && nameSize > 28) {
      nameSize -= 2;
      ctx.font = `700 ${nameSize}px ${SERIF}`;
    }
    ctx.save();
    ctx.fillStyle = text;
    ctx.textAlign = 'left';
    ctx.fillText(business.name, LEFT_PAD, 180);
    ctx.restore();

    const tagOff = slotOffsets.tagline;
    ctx.save();
    ctx.font = `italic 300 22px ${SERIF}`;
    ctx.fillStyle = textMuted;
    ctx.textAlign = 'left';
    ctx.fillText(slotValues.tagline, LEFT_PAD + tagOff.x, 220 + tagOff.y);
    ctx.restore();

    ctx.fillStyle = accent;
    ctx.fillRect(LEFT_PAD, 258, 50, 1);

    const phone = business.whatsappNumber.startsWith('+')
      ? business.whatsappNumber
      : '+' + business.whatsappNumber.replace(/\D/g, '');

    ctx.save();
    ctx.font = `500 11px ${SANS}`;
    (ctx as any).letterSpacing = '3px';
    ctx.fillStyle = textMuted;
    ctx.textAlign = 'left';
    ctx.fillText('WHATSAPP', LEFT_PAD + 1, 320);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();

    ctx.save();
    ctx.font = `400 22px ${SANS}`;
    ctx.fillStyle = text;
    ctx.textAlign = 'left';
    ctx.fillText(phone, LEFT_PAD, 350);
    ctx.restore();

    if (business.email) {
      ctx.save();
      ctx.font = `500 11px ${SANS}`;
      (ctx as any).letterSpacing = '3px';
      ctx.fillStyle = textMuted;
      ctx.textAlign = 'left';
      ctx.fillText('E-MAIL', LEFT_PAD + 1, 400);
      (ctx as any).letterSpacing = '0px';
      ctx.restore();

      ctx.save();
      ctx.font = `400 18px ${SANS}`;
      ctx.fillStyle = text;
      ctx.textAlign = 'left';
      ctx.fillText(business.email, LEFT_PAD, 428);
      ctx.restore();
    }

    const footOff = slotOffsets.footer;
    ctx.save();
    ctx.font = `500 11px ${SANS}`;
    (ctx as any).letterSpacing = '4px';
    ctx.fillStyle = accent;
    ctx.textAlign = 'left';
    ctx.fillText(slotValues.footer, LEFT_PAD + 1 + footOff.x, H - 60 + footOff.y);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();

    const RIGHT_CX = (DIVIDER_X + W) / 2;
    const RIGHT_CY = H / 2 - 10;
    const QR_SIZE = 340;
    const QR_PAD = 22;
    const QR_TILE = QR_SIZE + QR_PAD * 2;
    const qrX = RIGHT_CX - QR_TILE / 2;
    const qrY = RIGHT_CY - QR_TILE / 2;

    ctx.save();
    ctx.shadowColor = 'rgba(28, 26, 24, 0.10)';
    ctx.shadowBlur = 14;
    ctx.shadowOffsetY = 4;
    ctx.fillStyle = WHITE;
    ctx.fillRect(qrX, qrY, QR_TILE, QR_TILE);
    ctx.restore();

    ctx.drawImage(qrImage, qrX + QR_PAD, qrY + QR_PAD, QR_SIZE, QR_SIZE);

    const capOff = slotOffsets.caption;
    ctx.save();
    ctx.font = `500 11px ${SANS}`;
    (ctx as any).letterSpacing = '4px';
    ctx.fillStyle = textMuted;
    ctx.textAlign = 'center';
    ctx.fillText(slotValues.caption, RIGHT_CX + 2 + capOff.x, qrY + QR_TILE + 32 + capOff.y);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();
  },
};
